export default IconLogicBuffer => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-logic-buffer" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M22 12h-5" />
  <path d="M2 9h5" />
  <path d="M2 15h5" />
  <path d="M7 5l10 7l-10 7z" />
</svg>`;